import React, { useState } from "react";
import { Card, CardBody, Container, Button, Spinner } from "reactstrap";
import {
  perPageData,
  showToastMessage,
} from "../../../../common/service/CommonService";
import CommonOffcanvasLayout from "../../../../Components/Common/CommonOffcanvasLayout";
import styles from "../css/sponsor.module.scss";
import DeleteModal from "../../../../Components/Common/DeleteModal";
import AddEditSponsor from "../components/AddEditSponsor";
import { useSponserService } from "../api/useSponsorService";
import FilePreviewModal from "../../../Study/Attachments/components/FilePreviewModal";
import Reason from "../../../../common/utilities/Reason/Reason";
import CommonTableIndexWise from "../../../../Components/Common/CommonTableIndexWise";
import CommonSearch from "../../../../Components/Common/CommonSearch";
import {
  PERMISSION_ACTIONS,
  PERMISSION_MODULES,
} from "../../../../common/constants/PermissionConstants";
import CommonButton from "../../../../Components/Common/CommonButton";
import {
  SponsorFormValues,
  SponsorMasterRecord,
} from "../helper/sponsor.types";
import { sponsorColumn } from "../helper/sponsorconstant";
import { queryClient } from "api/queryClient";
import { useAuditService } from "modules/Audit/api/useAuditQuery";
import { normalizeFormValues } from "helpers/constant";

const SponsorList: React.FC = () => {
  document.title = "Sponsor | ZENTIXS VISTA";
  //-------------------------------------------------------------------------------------------
  //-->Use STATE
  //-------------------------------------------------------------------------------------------

  const [searchText, setSearchText] = useState<string>("");
  const [showAddEdit, setShowAddEdit] = useState<boolean>(false);
  const [editRecord, setEditRecord] = useState<SponsorMasterRecord | null>(
    null,
  );
  const [deleteModal, setDeleteModal] = useState<boolean>(false);
  const [selectedRecord, setSelectedRecord] =
    useState<SponsorMasterRecord | null>(null);
  const [currentPageNumber, setCurrentPageNumber] = useState(1);
  const [updatedRecord, setUpdatedRecord] = useState<SponsorFormValues | null>(
    null,
  );
  const [isReasonModal, setIsReasonModal] = useState<boolean>(false);
  const [showDeleteReason, setShowDeleteReason] = useState<boolean>(false);

  // TODO: Replace with useSponsorService when available
  const { SelectAllQuery, InsertMutation, UpdateMutation, DeleteMutation } =
    useSponserService(searchText, currentPageNumber, perPageData);

  //Audit
  const { SelectAllMutation: AuditMutation } = useAuditService();
  const [isPreviewOpen, setIsPreviewOpen] = useState<boolean>(false);
  const [previewFile, setPreviewFile] = useState<File | null>(null);

  //-------------------------------------------------------------------------------------------
  //--> Toggles
  //-------------------------------------------------------------------------------------------

  const toggleAddEditSponsor = (): void => setShowAddEdit(!showAddEdit);
  const toggleReasonModal = (): void => setIsReasonModal((prev) => !prev);
  const toggleDeleteModal = (): void => {
    setDeleteModal(!deleteModal);
    setShowDeleteReason(false);
  };
  const toggleDeleteReason = (): void => setShowDeleteReason(!showDeleteReason);

  //-------------------------------------------------------------------------------------------
  //--> Page Start
  //-------------------------------------------------------------------------------------------

  const {
    data: queryResponse,
    isLoading,
    isFetching,
  } = SelectAllQuery as {
    data?: { data?: (SponsorMasterRecord & { total_count: number })[] };
    isLoading: boolean;
    isFetching: boolean;
    isError: boolean;
  };


  const data: (SponsorMasterRecord & { total_count: number })[] =
    queryResponse?.data ?? [];
  //-------------------------------------------------------------------------------------------
  //--> On Reset Table Record
  //-------------------------------------------------------------------------------------------

  const refreshTableData = () => {
    // if (currentPageNumber === 1) {
    //   SelectAllQuery.refetch?.();
    // } else {
      setCurrentPageNumber(1);
    // }
  };

  //-------------------------------------------------------------------------------------------
  //--> ON SEARCH
  //-------------------------------------------------------------------------------------------

  const onSearch = (text: string | null) => {
          setSearchText(text ?? "");
          setCurrentPageNumber(1);  
  };
  //-------------------------------------------------------------------------------------------
  //--> On Add Master
  //-------------------------------------------------------------------------------------------

  const onAddMaster = (): void => {
    setEditRecord(null);
    toggleAddEditSponsor();
  };

  //-------------------------------------------------------------------------------------------
  //--> On Edit Master
  //-------------------------------------------------------------------------------------------

  const onEditMaster = (item: SponsorMasterRecord): void => {
    const formValues: SponsorMasterRecord = {
      sponsorid: item.sponsorid || (item as any).sponsorid,
      sponsorname: item.sponsorname,
      sponsoraddress: item.sponsoraddress,
      sponsorcontact: item.sponsorcontact,
      sponsoremail: item.sponsoremail,
      croname: item.croname,
      crocontact: item.crocontact,
      croemail: item.croemail,
    };
    setEditRecord(formValues);
    toggleAddEditSponsor();
  };

  //-------------------------------------------------------------------------------------------
  //--> Record Update Master
  //-------------------------------------------------------------------------------------------

  const btnReasonClick = (reasonPayload: {
    id: number | null;
    reason: string;
  }) => {
    if (!editRecord || editRecord.sponsorid == null || !updatedRecord) return;

    const payload = {
      sponsorid: editRecord.sponsorid,
      sponsorname: updatedRecord.sponsorname,
      sponsoraddress: updatedRecord.sponsoraddress,
      sponsorcontact: updatedRecord.sponsorcontact,
      sponsoremail: updatedRecord.sponsoremail,
      croname: updatedRecord.croname,
      crocontact: updatedRecord.crocontact,
      croemail: updatedRecord.croemail,
      updatereason: reasonPayload.reason,
    };

    const normalizedValues = normalizeFormValues(payload);

    UpdateMutation.mutate(normalizedValues as any, {
      onSuccess: (response) => {
        setSearchText("");
        setCurrentPageNumber(1);
        queryClient.invalidateQueries({
          queryKey: [
            "sponser-selectAll",
            searchText,
            currentPageNumber,
            perPageData,
          ],
        });
        showToastMessage("success", response?.message);
        toggleReasonModal();
        toggleAddEditSponsor();
        setEditRecord(null);
      },
      onError: (error: any) => {
        showToastMessage("error", error?.message ?? error);
      },
    });
  };

  //-------------------------------------------------------------------------------------------
  //--> Record Insert / Update Master
  //-------------------------------------------------------------------------------------------

  const onSaveMaster = (record: SponsorFormValues): void => {
    // EDIT
    if (editRecord?.sponsorid) {
      setUpdatedRecord(record);
      toggleReasonModal();
    }
    // ADD

    else {
      const payload = {
        sponsorname: record.sponsorname,
        sponsoraddress: record.sponsoraddress,
        sponsorcontact: record.sponsorcontact,
        sponsoremail: record.sponsoremail,
        croname: record.croname,
        crocontact: record.crocontact,
        croemail: record.croemail,
      };

      const normalizedValues = normalizeFormValues(payload);


      InsertMutation.mutate(normalizedValues as any, {
        onSuccess: (response) => {
          refreshTableData();
          setSearchText("");
          setCurrentPageNumber(1);
          showToastMessage("success", response?.message);
          toggleAddEditSponsor();
        },
        onError: (error: any) => {
          showToastMessage("error", error?.message ?? error);
          setEditRecord(null);
        },
      });
    }
  };
  //-------------------------------------------------------------------------------------------
  //--> Record Delete
  //------------------------------------------------------------------------------------------

  const onDelete = (item: SponsorMasterRecord): void => {
    setSelectedRecord(item);
    setDeleteModal(true);
  };

  const confirmDelete = (reasonPayload: {
    id: number | null;
    reason: string;
  }): void => {
    if (!selectedRecord || reasonPayload.id === null) return;

    const payload = {
      sponsorid: reasonPayload.id,
      updatereason: reasonPayload.reason,
    };

    DeleteMutation.mutate(payload, {
      onSuccess: (response) => {
        const totalRecords = data[0]?.total_count || 0;
        const updatedTotalRecords = totalRecords - 1;
        const lastPage = Math.ceil(updatedTotalRecords / perPageData);
        const updatedPage =
          lastPage === 0 ? 1 : Math.min(currentPageNumber, lastPage);
        setCurrentPageNumber(updatedPage);
        queryClient.invalidateQueries({
          queryKey: ["sponser-selectAll", searchText, updatedPage, perPageData],
        });
        showToastMessage("success", response?.message);
        setSearchText("");
        toggleDeleteModal();
        setSelectedRecord(null);
      },
      onError: (error: Error) => {
        showToastMessage("error", error?.message ?? error);
      },
    });
  };

  const onAuditClick = () => {
    const payload = {
      modulename: "Sponsor",
    };

    AuditMutation.mutate(payload, {
      onSuccess: (data: any) => {
        if (data instanceof Blob) {
          const pdfFile = new File([data], "Sponsor_Audit_Log.pdf", {
            type: "application/pdf",
          });
          setPreviewFile(pdfFile);
          setIsPreviewOpen(true);
        }
      },
      onError: (error: any) => {
        showToastMessage("error", error?.message ?? error);
        console.error("Error fetching audit logs:", error);
      },
    });
  };

  const tableData = data.map((row) => ({ ...row }));

  return (
    <div className="page-content">
      <Container fluid className="px-0">
        <Card >
          <CardBody>
            <div className="d-flex justify-content-between align-items-center mb-3">
              <CommonSearch onSearch={onSearch} searchText={searchText} />
              <div className="d-flex gap-2">
                <CommonButton
                  module={PERMISSION_MODULES.SPONSOR}
                  action={PERMISSION_ACTIONS.AUDIT}
                  color="primary"
                  size="sm"
                  onClick={onAuditClick}
                  disabled={AuditMutation.isPending}
                  outline
                >
                  {AuditMutation.isPending ? (
                    <Spinner size="sm" className="me-2" />
                  ) : (
                    <i className="ri-history-line me-1"></i>
                  )}
                  Audit
                </CommonButton>
                <CommonButton
                  module={PERMISSION_MODULES.SPONSOR}
                  action={PERMISSION_ACTIONS.ADD}
                  color="primary"
                  size="sm"
                  onClick={onAddMaster}
                  outline
                >
                  <i className="ri-add-line me-1"></i> Add
                </CommonButton>
              </div>
            </div>
            <CommonTableIndexWise
              columns={sponsorColumn}
              data={tableData}
              showStatus={false}
              actions={{
                onEdit: onEditMaster,
                onDelete,
              }}
              moduleName={PERMISSION_MODULES.SPONSOR}
              pageSize={perPageData}
              currentPage={currentPageNumber}
              onPageChange={setCurrentPageNumber}
              totalRecords={data[0]?.total_count || 0}
              loading={isLoading || isFetching}
            />
          </CardBody>
        </Card>

        {/* Add/Edit Off-Canvas */}
        <AddEditSponsor
          isOpen={showAddEdit}
          toggle={toggleAddEditSponsor}
          existingData={editRecord}
          onSave={onSaveMaster}
          isLoading={InsertMutation.isPending}
        />


        {/* Delete Modal */}
        {deleteModal && (
          <DeleteModal
            isopen={deleteModal}
            toggle={toggleDeleteModal}
            recordId={
              selectedRecord?.sponsorid ??
              (selectedRecord as any)?.sponsorid ??
              0
            }
            recordName={selectedRecord?.sponsorname}
            onDeleteClick={confirmDelete}
            showDeleteReason={showDeleteReason}
            toggleDeleteReason={toggleDeleteReason}
            isLoading={DeleteMutation?.isPending}
          />
        )}
        {/* Reason Modal */}
        {isReasonModal && editRecord?.sponsorid != null && (
          <Reason
            isOpen={isReasonModal}
            toggle={toggleReasonModal}
            action="Update"
            id={editRecord.sponsorid}
            click={btnReasonClick}
            isLoading={UpdateMutation.isPending}
          />
        )}

        {/* File Preview Modal */}
        {isPreviewOpen && (
          <FilePreviewModal
            file={previewFile}
            isOpen={isPreviewOpen}
            size={"xl"}
            onClose={() => {
              setIsPreviewOpen(false);
              setPreviewFile(null);
            }}
          />
        )}
      </Container>
    </div>
  );
};

export default SponsorList;
